import { useQuery } from '@tanstack/react-query';
import { organizationApi } from '../api/organizationApi';
import { Organization } from '../types/organization';

/**
 * Хук для получения списка доступных организаций
 * Использует React Query для кэширования и управления состоянием загрузки
 */
export const useOrganizations = () => {
  return useQuery<Organization[], Error>({
    queryKey: ['organizations'],
    queryFn: organizationApi.getOrganizations,
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 2,
    refetchOnWindowFocus: false,
  });
}; 